const DEFAULT_TIME = "18:05:00";

const pad = (value) => String(value).padStart(2, "0");

const formatDateTime = (date, time = DEFAULT_TIME) => {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate(),
  )} ${time}`;
};

const getBaseTradeDate = () => {
  const today = new Date();
  const baseDate = new Date(today);
  const day = baseDate.getDay();

  if (day === 6) {
    baseDate.setDate(baseDate.getDate() - 1);
    return baseDate;
  }

  if (day === 0) {
    baseDate.setDate(baseDate.getDate() - 2);
    return baseDate;
  }

  baseDate.setDate(baseDate.getDate() - 5);
  return baseDate;
};

export const getDefaultTradeExecutionTimestamp = () => {
  return formatDateTime(getBaseTradeDate());
};

export const getDefaultTradeExpiryTimestamp = () => {
  const expiryDate = new Date(getBaseTradeDate());
  expiryDate.setMonth(expiryDate.getMonth() + 1);
  return formatDateTime(expiryDate);
};
